function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__top-left">
                <div className="product-info__title title-def title-def_sec2">Силиконовая резина общего назначения</div>
                <div className="product-info__title title-def title-def_sec3">Формовая</div>
              </div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/9.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <h4>Описание</h4>
              <p>Силиконовая резиновая смесь общего назначения, с хорошими физико-механическими свойствами, легко окрашивается.</p>
              <p>Применяется для изготовления изделий методом формования. Рекомендуется для производства формовых резинотехнических изделий, в том числе уплотнительных колец, манжет и т.п.</p>
              <p></p>
              <h4>Основные характеристики</h4>
              <a href={window.location.origin+"/products/silikonovye-reziny/rezina-formovaya/Rutesil-M24-2.pdf"} download target="_blank">Rutesil® M 24/2</a>
              <br/>
              <a href={window.location.origin+"/products/silikonovye-reziny/rezina-formovaya/Rutesil-M26-2.pdf"} download target="_blank">Rutesil® M 26/2</a>
              <p></p>
              <h4>Упаковка</h4>
              <p>Гофрокартон, 20 кг.</p>
              <p></p>
              <h4>Хранение</h4>
              <p>Хранить в защищенном от атмосферных воздействий, сухом месте. Гарантийный срок хранения – 12 месяцев с даты производства (информация дана на этикетке или в сертификате качества для каждой партии). По истечении периода продукт может быть использован после повторной проверки свойств.</p>
              <p></p>
              <h4>Указания по безопасности</h4>
              <p>Продукт стабилен и не опасен при нормальных условиях.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;